import { Component, OnInit, OnDestroy } from '@angular/core';
import { CurrentUserService } from 'src/app/core/services/current-user.service';
import { FlashMessageService } from 'src/app/shared/services/flash-message.service';
import { RedirctUrlService } from 'src/app/shared/services/redirct-url.service';
import { Location } from '@angular/common';
import { HeaderService } from 'src/app/shared/services/header/header.service';
import { AppNotificationService } from 'src/app/shared/services/app-notification.service'
import { GoogleAnalyticsService } from 'src/app/shared/services/google-analytics/google-analytics.service';
import { RegexEnum } from 'src/app/core/enum/regex.enum';

@Component({
  selector: 'app-my-account',
  templateUrl: './my-account.component.html',
  styleUrls: ['./my-account.component.scss']
})
export class MyAccountComponent implements OnInit {
  public phoneMask = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
  public loading: boolean = false;
  public currentUser: string = '';
  public displayNotifications: boolean = false;
  public notifcationPreference: any = {
    pickup: { email: false, text: false },
    eta: { email: false, text: false },
    delayed: { email: false, text: false },
    delivery: { email: false, text: false },
    planned: { email: false, text: false }
  };
  public notifications: any[] = [];
  public hasMobilePhone: boolean = false;
  private phoneRegex = new RegExp(/^\D?(\d{3})\D?\D?(\d{3})\D?(\d{4})$/);
  public regexEnum = RegexEnum;

  constructor(
    public currentUserService: CurrentUserService,
    private flashMessageService: FlashMessageService,
    private location: Location,
    private _gaSvc: GoogleAnalyticsService,
    private _redirectUrl: RedirctUrlService,
    public _header: HeaderService,
    public appNotificationsService: AppNotificationService
  ) { }

  async ngOnInit() {
    this.loading = true;
    this.currentUserService.getNotificationPreferences().then(preference => {
      this.notifcationPreference = this.mapPreference(preference)
      this.loading = false;
    }).catch((error) => {
      this.flashMessageService.updateMessage(`Could not get user notification preferences: ${error}`);
      this.loading = false;
    });

    this.currentUserService.getUser().then(user => {
      this.currentUser = this.currentUserService.user.firstname;
      if (this.currentUserService.user.organizationType === "CUSTOMER" || this.currentUserService.user.organizationType === "SUPPLIER") {
        this.displayNotifications = true;
        if (this.currentUserService.user.alternatePhone) {
          this.hasMobilePhone = true;
        }
      } else {
        this.displayNotifications = false;
        this.hasMobilePhone = false;
      }
    });

    if (await this.appNotificationsService.getNotificationEnabledStatus()) this.appNotificationsService.loadNotifications('general', 0);
  }

  ngOnDestroy() {

  }

  private mapPreference(preference) {
    if (!preference.pickup) {
      preference.pickup = { email: false, text: false };
    }

    if (!preference.eta) {
      preference.eta = { email: false, text: false };
    }

    if (!preference.delayed) {
      preference.delayed = { email: false, text: false };
    }

    if (!preference.delivery) {
      preference.delivery = { email: false, text: false };
    }

    if (!preference.planned) {
      preference.planned = { email: false, text: false };
    }

    return preference;
  }

  updatePreferences(type, value) {
    this._gaSvc.register(`User Preferences`, `User has updated their notification preferences`);
  }

  onSubmit() {
    this.loading = true;
    this._gaSvc.register(`User Preferences`, `User has updated their user preferences`);
    Promise.all([this.currentUserService.editUser(), this.currentUserService.setNotificationPreferences(this.notifcationPreference)])
      .then(() => {
        this.loading = false;
        this.flashMessageService.updateMessage("Successfully updated account details.", 3000, "success");
      }).catch((error) => {
        this.loading = false;
        this.flashMessageService.updateMessage(`Error: ${error}`);
      });
  }

  onRedirectHandler(event) {
      this._redirectUrl.onLogoutHandler(event);
  }

  onBackEventHandler() {
    this.location.back();
  }

  updateValidity() {
    if (this.phoneRegex.test(this.currentUserService.user.alternatePhone)) {
      this.hasMobilePhone = true;
    } else {
      this.hasMobilePhone = false;
    }
  }

}
